/* eslint-disable array-callback-return */
/*
 * 帮助中心
 */
import React from "react";
import {API, ROOT, history} from "../../../static/js/common";
import eventBus from "../../../static/js/events";
import {
  message,
  Input,
  Button,
  Spin,
  Modal,
  Tooltip,
} from "antd";
import { CopyOutlined, SafetyCertificateOutlined } from '@ant-design/icons';

const { TextArea } = Input;

class CollectList extends React.Component {
  constructor(props) {
    super(props);
      this.state = {
        path: 'question',
        page: 1,
        pageSize: 100,
        article_data: {},
        // 智能问答相关状态
        chatMessages: [],
        currentQuestion: '',
        isLoading: false,
        showUpgradePrompt: false,
        // 图片相关状态
        selectedImage: null, // 兼容历史（不再使用）
        uploadedImageUrls: [], // 新增：已上传图片的 URL 列表（最多 10）
        // 会话ID按智能体维度保存，便于在各自智能体内连续对话
        conversationIdMap: {
          unblock: null,
          tax: null,
        },
        // 智能体选择参数（unblock: 电商解封助手, tax: 电商税务咨询）
        agentType: 'unblock',
        imageModalVisible: false,
        imageModalSrc: '',
        imageModalTitle: '',
      };
    // 逐字流式展示的定时器集合（按消息ID存储）
    this.streamTimers = new Map();
    // 组件激活标记，控制异步回调在卸载后不再执行
    this.isActive = true;
    // 创建聊天消息容器的ref
    this.chatMessagesRef = React.createRef();
    // 图片输入框ref
    this.imageInputRef = React.createRef();
  }

  componentDidMount() {
    // 页面挂载，标记为激活
    this.isActive = true;
    if(this.getUrlParams('path')){
      this.setState({path: this.getUrlParams('path')});
    }
    this.getArticleList();

    eventBus.on('changeHelpType', () => {
      // 切换帮助类型时，结束当前流式并结束会话
      this.finishStreaming && this.finishStreaming();
      this.endAllConversations && this.endAllConversations();
      this.setState({path: 'express'})
    })
  }

  // 模拟智能问答数据（按智能体类型准备的示例问答）
  mockAnswers = {
    '问：我的一家拼多多店铺还有三万多的货款，但是现在提不出来。平台说我销售假货，有什么办法可以拿出来？': `
一、 冻结类型判断
根据您提供的信息，我们初步判断您的账户冻结属于知识产权侵权。
判断依据: 平台明确提示 “因涉及销售假货” 导致资金冻结。根据我国《商标法》第 57 条及《电子商务法》第 42 条，“销售侵犯注册商标专用权的商品” 属于典型的知识产权侵权行为。在知识库中，67% 的 “假货销售” 类冻结案件均被归类为知识产权侵权，且平台通常以 “假货” 作为商标侵权的直接指控依据，符合 A 类（知识产权侵权）的核心特征。

二、 解封可能性与金额评估
综合分析您的案件及知识库案例，评估如下：
账户解冻可能性: 中 - 低
理由：
1.侵权定性严重：“销售假货” 属于《电子商务法》第 44 条规定的 “严重侵犯知识产权行为”，平台有权对侵权商品及资金进行冻结，且申诉失败后仍有较高处理力度（类似案件中 73% 的申诉失败后维持冻结的判例）。
2.证据门槛高：若无法提供完整正品证据链（如品牌授权、正规进货渠道、检测报告），法院通常倾向于支持平台 “保护商标权” 的冻结措施。
3.例外情形：若能证明 “已尽到合理注意义务”（如供应商提供虚假资质、品牌方存在过错），可能争取部分解冻。

资金解冻金额评估: 部分解冻（具体比例需结合证据链完整性）
1.全额解冻概率极低：除非平台主动撤销指控或法院认定 “无侵权事实”，否则全额解冻可能性仅约 12%。
2.部分解冻可行性：若能提供 “正品授权 + 合理进货渠道” 证据，可争取解冻 50%-80% 资金；若仅能证明 “商品非故意侵权”，可能解冻 30%-50%。
3.最坏情况：若无法举证，资金可能被全部扣除。

三、紧急行动建议
1.立即收集核心证据：优先联系供应商获取《正品授权书》《进货发票》，并要求其对 “假货” 指控提供书面说明（证明非自身责任）；
2.申请平台二次审核：通过 “店铺违规申诉” 入口提交补充证据（如检测报告、品牌授权书），强调“已尽到合理注意义务”；
3.法律途径备选：若平台拒绝协商，需在收到冻结通知后 30 日内向法院提起诉讼，提交完整证据链（重点证明 “非故意侵权 + 合理注意义务”）。`,

    '问：我是做电商的，目前三个店铺年销售额大概是 5000 万左右，利润只有 5-7 个点，我交税之后公司是不是要亏本了？': `
一、问题归类
根据我们的分析，您的情况最符合税务缴纳问题，而这类店铺在新规下可能因合规成本增加（如补税、调整账目）导致实际利润被侵蚀，最终面临 “利润不足以覆盖税务成本” 的风险。

二、法规解读
1.企业所得税与利润虚高风险
根据中国《企业所得税法》及相关规定，若您的店铺存在无票采购支出（如供应商无法提供正规发票），会导致成本扣除不足，利润被高估，从而多缴企业所得税（按 25% 税率计算）。

2.合规成本与税务稽查风险
即使利润未虚高，年销售额 5000 万的电商企业合规成本（如聘请财务、税务申报、票据管理等）通常占营收的 2%-5%，5000 万 ×5%=250 万，可能进一步抵消现有利润。此外，若存在刷单、无票交易等不合规行为，税务系统通过平台数据比对易触发预警，面临补税 + 罚款（最高 5 倍）风险，亏损可能性更高。

三、解决方案
结合您的情况，建议从以下三方面降低税务成本、避免亏损：
1. 优化产品结构，降低无票风险
筛选高毛利合规产品：优先保留毛利率≥15%（如知识付费、3C 数码等）且供应商能提供正规发票的产品，逐步下架低毛利（如低于 10%）或无票采购的产品（如部分低价服饰、日用品）。

2. 规范账务与资金流转
所有收入走对公账户：拒绝私人账户收款，避免 “隐匿收入” 风险（按《税收征管法》，隐匿收入可能面临追缴税款 + 0.5-5 倍罚款）。
合理处理无票支出：500 元以下小额支出（如零星采购、快递费）可凭收款凭证入账；大额支出（如采购原材料）要求供应商代开发票，避免因无票导致利润虚高。

3. 自查税务风险，避免额外支出
核对平台数据与申报记录：确保所有交易（包括刷单、退款等）均通过平台如实申报，避免因数据差异（如平台流水与申报收入不符）触发税务稽查。
补报未申报收入：若过去存在部分线下交易未入账，及时通过 “自查补报” 处理，避免高额罚款（按《税收征管法》第 63 条，少缴税款可处 0.5-5 倍罚款）。`,
  };

  // 自动滚动到底部
  scrollToBottom = () => {
    if (!this.isActive) return;
    setTimeout(() => {
      if (!this.isActive) return;
      const el = this.chatMessagesRef && this.chatMessagesRef.current;
      if (el && typeof el.scrollHeight === 'number') {
        try { el.scrollTop = el.scrollHeight; } catch (_) {}
      }
    }, 80);
  };

  // 选择图片
  handleImageSelected = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    // 校验数量与类型、大小
    const { uploadedImageUrls } = this.state;
    if (uploadedImageUrls.length + files.length > 10) {
      message.warning('最多只能上传 10 张图片');
      return;
    }
    for (const f of files) {
      if (!f.type || !f.type.startsWith('image/')) {
        message.warning('仅支持图片文件');
        return;
      }
      if (f.size > 10 * 1024 * 1024) {
        message.warning('单个文件最大 10MB');
        return;
      }
    }

    // 通过接口上传图片（multipart/form-data）
    this.uploadImagesToServer(files)
      .then((urls) => {
        if (!urls || !urls.length) {
          message.error('上传失败，请重试');
          return;
        }
        this.setState({ uploadedImageUrls: [...uploadedImageUrls, ...urls] });
      })
      .catch(() => message.error('上传失败，请稍后重试'))
      .finally(() => {
        // 清空文件输入框
        if (this.imageInputRef.current) {
          this.imageInputRef.current.value = '';
        }
      });
  };

  // 清除已选图片
  handleClearImage = () => {
    this.setState({ selectedImage: null, uploadedImageUrls: [] });
    if (this.imageInputRef.current) {
      this.imageInputRef.current.value = '';
    }
  };

  // 删除单张已上传图片
  handleRemoveImage = (url) => {
    this.setState((prev) => ({
      uploadedImageUrls: (prev.uploadedImageUrls || []).filter(u => u !== url)
    }));
  };

  // 上传图片到服务端，返回 URL 数组
  uploadImagesToServer = async (files) => {
    try {
      const token = window.localStorage.getItem('dfToken') || '';
      const url = `${ROOT}/ai/uploadImages?_t=${Date.now()}&token=${encodeURIComponent(token)}`;
      const formData = new FormData();
      files.forEach(f => formData.append('files', f));
      const res = await fetch(url, { method: 'POST', body: formData });
      const json = await res.json();
      const isOk = json && ((json.status * 1) === 0 || (json.errno * 1) === 0);
      const list = (json && json.extData && Array.isArray(json.extData.success))
        ? json.extData.success
        : (json && json.data && Array.isArray(json.data.success))
          ? json.data.success
          : [];
      const failedCount = (json && json.extData && typeof json.extData.failedCount !== 'undefined')
        ? json.extData.failedCount
        : (json && json.data && typeof json.data.failedCount !== 'undefined')
          ? json.data.failedCount
          : 0;

      if (isOk && list.length > 0) {
        const clean = (s) => (s || '').toString().trim().replace(/^`+|`+$/g, '').replace(/^"+|"+$/g, '').replace(/^\'+|\'+$/g, '');
        const urls = list.map(item => clean(item.url)).filter(Boolean);
        if (urls.length > 0) {
          const msgText = (json.message || `上传完成：成功 ${urls.length} 张，失败 ${failedCount} 张`);
          message.success(msgText);
        } else {
          message.error('上传失败：未返回有效图片地址');
        }
        return urls;
      }
      message.error(json && json.message ? json.message : '上传失败，请稍后重试');
      return [];
    } catch (err) {
      return [];
    }
  };

  // 获取用户ID（从 localStorage 读取，若无则置为 '0'，后端可通过token识别）
  getUserId = () => {
    // 优先使用 localStorage.lawyer
    try {
      const lawyerStr = window.localStorage.getItem('lawyer');
      if (lawyerStr) {
        let candidate = null;
        try {
          const lawyerObj = JSON.parse(lawyerStr);
          candidate = lawyerObj;
        } catch (_e) {
          candidate = lawyerStr; // 非JSON时直接使用原字符串
        }
        if (candidate) return String(candidate);
      }
    } catch (e) {}

    // 回退到 localStorage.user.loginId 或 loginId
    try {
      const userStr = window.localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr || '{}');
        const uid = user && (user.loginId || user.loginid || user.id || user.userId);
        if (uid) return String(uid);
      }
    } catch (e) {}
    const fallback = window.localStorage.getItem('loginId');
    return fallback || '0';
  };

  // 预检提问权限
  checkQuestionPermission = async () => {
    try {
      const token = window.localStorage.getItem('dfToken') || '';
      const userId = this.getUserId();
      const url = `${ROOT}/ai/checkQuestion?userId=${encodeURIComponent(userId)}&_t=${Date.now()}&token=${encodeURIComponent(token)}`;
      const res = await fetch(url, { method: 'GET' });
      const json = await res.json();
      const ok = json && ((json.status * 1) === 0 || (json.errno * 1) === 0);
      const data = json && (json.data || json.extData) || {};
      const questionNum = Number(data.questionNum);
      const remainFreeCount = Number(data.remainFreeCount);
      const cost = Number(data.costPerQuestion || 500);
      const canAsk = !!data.canAsk && ok;
      const isFree = Number.isFinite(remainFreeCount)
        ? remainFreeCount > 0
        : (Number.isFinite(questionNum) ? questionNum < 2 : false); // 前2次免费
      const errmsg = (json && (json.errmsg || json.message)) || '';
      return { ok, canAsk, isFree, cost, data, json, errmsg };
    } catch (e) {
      return { ok: false, canAsk: false, isFree: false, cost: 500, data: {}, json: null, errmsg: '网络异常，请稍后重试' };
    }
  };

  // 将 agentType 映射为后端的 agentKey
  getAgentKey = (agentType) => {
    if (agentType === 'tax') return 'SW';
    return 'JF'; // 默认电商解封助手
  };

  // Coze 的 user_id，取 localStorage.user.username
  getCozeUserId = () => {
    try {
      const userStr = window.localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr || '{}');
        if (user && user.username) return String(user.username);
      }
    } catch (e) {}
    return 'default_user';
  };

  // 调用结束会话接口
  endConversation = async (conversationId) => {
    if (!conversationId) return false;
    try {
      const token = window.localStorage.getItem('dfToken') || '';
      const url = `${ROOT}/ai/endConversation?conversationId=${encodeURIComponent(conversationId)}&_t=${Date.now()}&token=${encodeURIComponent(token)}`;
      const res = await fetch(url, { method: 'POST' });
      const json = await res.json();
      const ok = json && ((json.status * 1) === 0 || (json.errno * 1) === 0);
      return !!ok;
    } catch (e) {
      return false;
    }
  };

  // 结束当前智能体的会话
  endConversationsByAgent = async (agentType) => {
    const convId = (this.state.conversationIdMap || {})[agentType];
    if (convId) {
      await this.endConversation(convId);
    }
    this.setState((prev) => ({
      conversationIdMap: { ...prev.conversationIdMap, [agentType]: null }
    }));
  };

  // 结束所有会话
  endAllConversations = async () => {
    try {
      const ids = Object.values(this.state.conversationIdMap || {}).filter(Boolean);
      await Promise.all(ids.map((id) => this.endConversation(id)));
      this.setState({ conversationIdMap: { unblock: null, tax: null } });
    } catch (e) {}
  };

  // 切换智能体并清空当前会话与输入状态
  handleSwitchAgent = (newType) => {
    const { agentType } = this.state;
    if (newType === agentType) return;
    // 清理现有流式定时器
    this.streamTimers.forEach((timer) => clearInterval(timer));
    this.streamTimers.clear();
    this.setState({
      agentType: newType,
      chatMessages: [],
      currentQuestion: '',
      selectedImage: null,
      isLoading: false,
    }, () => {
      if (this.imageInputRef.current) {
        this.imageInputRef.current.value = '';
      }
    });
  };

  // 切换智能体前的确认弹窗
  handleConfirmSwitch = (newType) => {
    const { agentType, chatMessages } = this.state;
    if (newType === agentType) return;
    const hasAsked = Array.isArray(chatMessages) && chatMessages.some(m => m.type === 'user');
    if (!hasAsked) {
      // 没有提过问题，直接切换无需确认
      this.endConversationsByAgent(agentType).then(() => this.handleSwitchAgent(newType));
      return;
    }
    Modal.confirm({
      title: '确认结束当前对话么？',
      content: '结束对话后本次对话内容将会被清空',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        await this.endConversationsByAgent(agentType);
        this.handleSwitchAgent(newType);
      },
    });
  };

  // 处理智能问答（支持仅发送图片），增加预检权限与扣费确认
  handleAskQuestion = async () => {
    const { currentQuestion, chatMessages, uploadedImageUrls, agentType, conversationIdMap } = this.state;
    const text = (currentQuestion || '').trim();
    // 预检权限（优先调用，便于观察是否真正请求了接口）
    const check = await this.checkQuestionPermission();
    if (!check.ok) {
      const lines = [];
      if (check.errmsg) lines.push(check.errmsg);
      if (check.data && check.data.message) lines.push(check.data.message);
      lines.push('再次提问需要5元');
      Modal.confirm({
        title: '无法提问',
        content: <div style={{ whiteSpace: 'pre-wrap' }}>{lines.join('\n')}</div>,
        okText: '知道了',
        cancelText: '去充值',
        onCancel: () => window.open('https://df.duoduolang.com/#/seller/finance/recharge', '_blank'),
      });
      return;
    }
    const { canAsk, isFree, cost } = check;
    if (!canAsk) {
      Modal.confirm({
        title: '余额不足',
        content: (
          <div style={{ whiteSpace: 'pre-wrap' }}>
            {`再次提问需要 ${(cost/100).toFixed(2)} 元，请先充值。`}
            {check.data && check.data.message ? `\n${check.data.message}` : ''}
          </div>
        ),
        okText: '去充值',
        cancelText: '取消',
        onOk: () => window.open('https://df.duoduolang.com/#/seller/finance/recharge', '_blank'),
      });
      return;
    }
    if (!isFree) {
      const ok = await new Promise((resolve) => {
        Modal.confirm({
          title: '扣费确认',
          content: `继续提问将扣除账户余额 ${(cost/100).toFixed(2)} 元，是否继续？`,
          okText: '继续',
          cancelText: '取消',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!ok) return;
    }

    // 校验内容（通过预检后再校验输入）
    if (!text && (!uploadedImageUrls || uploadedImageUrls.length === 0)) {
      message.warning('请输入您的问题或选择图片');
      return;
    }

    // 进入提问流程（先加入用户消息）
    const userMessage = {
      id: Date.now(),
      type: 'user',
      content: text,
      images: Array.isArray(uploadedImageUrls) ? [...uploadedImageUrls] : [],
      timestamp: new Date().toLocaleTimeString(),
      agentType,
    };

    this.setState({
      chatMessages: [...chatMessages, userMessage],
      currentQuestion: '',
      isLoading: true,
      selectedImage: null,
      uploadedImageUrls: [],
    }, () => {
      this.scrollToBottom();
      if (this.imageInputRef.current) {
        this.imageInputRef.current.value = '';
      }
    });

    // 调用真实智能体接口
    try {
      const agentKey = this.getAgentKey(agentType);
      const userId = this.getUserId();
      const user_id = this.getCozeUserId();
      const clean = (s) => (s || '').toString().trim().replace(/^`+|`+$/g, '').replace(/^"+|"+$/g, '').replace(/^\'+|\'+$/g, '');
      const imageUrls = (uploadedImageUrls || []).map(u => clean(u));
      const token = window.localStorage.getItem('dfToken') || '';
      const currentConvId = conversationIdMap[agentType];
      const q = currentConvId ? `?conversationId=${encodeURIComponent(currentConvId)}&_t=${Date.now()}&token=${encodeURIComponent(token)}` : `?_t=${Date.now()}&token=${encodeURIComponent(token)}`;
      const url = `${ROOT}/ai/runagent${q}`;
      const body = {
        agentKey,
        userId: Number(userId),
        inputs: {
          query: text,
          imageUrls,
          user_id,
        },
      };
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const json = await res.json();
      const ok = json && ((json.status * 1) === 0 || (json.errno * 1) === 0);
      const data = json && (json.data || json.extData) || {};
      const answer = data.answer || (json.errmsg || '调用失败，请稍后重试');
      const newConvId = data.conversation_id || data.conversationId || currentConvId || null;

      if (!this.isActive) return; // 页面已切换/卸载，忽略结果
      const botMessageId = Date.now() + 1;
      const botMessage = {
        id: botMessageId,
        type: 'bot',
        content: '',
        fullContent: answer,
        timestamp: new Date().toLocaleTimeString(),
        agentType,
      };
      this.setState((prev) => ({
        chatMessages: [...prev.chatMessages, botMessage],
        isLoading: false,
        conversationIdMap: { ...prev.conversationIdMap, [agentType]: newConvId },
      }), () => {
        this.scrollToBottom();
        if (this.isActive) {
          this.startStream(botMessageId, answer);
        }
      });
    } catch (err) {
      if (!this.isActive) return; // 页面已切换/卸载，忽略结果
      const botMessageId = Date.now() + 1;
      const failText = '网络异常或服务不可用，请稍后再试。';
      const botMessage = {
        id: botMessageId,
        type: 'bot',
        content: '',
        fullContent: failText,
        timestamp: new Date().toLocaleTimeString(),
        agentType,
      };
      this.setState((prev) => ({
        chatMessages: [...prev.chatMessages, botMessage],
        isLoading: false,
      }), () => {
        this.scrollToBottom();
        if (this.isActive) {
          this.startStream(botMessageId, failText);
        }
      });
    }
  };

  // 复制机器人答案到剪贴板
  handleCopy = async (text) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text || '');
      } else {
        const el = document.createElement('textarea');
        el.value = text || '';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
      message.success('已复制到剪贴板');
    } catch (e) {
      message.error('复制失败，请稍后重试');
    }
  };

  // 示例问题：点击“答”按钮弹出答案弹框
  openAnswerModal = (questionKey) => {
    const answer = this.mockAnswers[questionKey] || '暂未找到该问题的参考答案';
    Modal.info({
      title: '答',
      okText: '确定',
      width: 800,
      content: (
        <div style={{ whiteSpace: 'pre-wrap' }}>{answer}</div>
      ),
    });
  };

  // 将答案按“文档视图”渲染（标题、段落、有序列表）
  renderDoc = (text = '') => {
    try {
      const lines = String(text).split(/\n+/).map((l) => l.trim());
      const nodes = [];
      let listBuffer = [];
      let ulBuffer = [];
      const escapeHtml = (s) => s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      const renderInline = (s) => {
        const html = escapeHtml(s)
          .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
          .replace(/\*(.+?)\*/g, '<em>$1</em>');
        return <span dangerouslySetInnerHTML={{ __html: html }} />;
      };
      const flushList = () => {
        if (listBuffer.length) {
          nodes.push(
            <ol className="doc-ol" key={`ol-${nodes.length}`}>
              {listBuffer.map((li, idx) => (
                <li key={`li-${idx}`}>{li.replace(/^\d+[\.、]\s*/, '')}</li>
              ))}
            </ol>
          );
          listBuffer = [];
        }
        if (ulBuffer.length) {
          nodes.push(
            <ul className="doc-ul" key={`ul-${nodes.length}`}>
              {ulBuffer.map((li, idx) => (
                <li key={`uli-${idx}`}>{renderInline(li.replace(/^(\*|-)\s*/, ''))}</li>
              ))}
            </ul>
          );
          ulBuffer = [];
        }
      };
      lines.forEach((line, i) => {
        if (!line) { flushList(); return; }
        // Markdown 标题 # ## ###
        const mdHeading = line.match(/^(#{1,6})\s+(.*)$/);
        if (mdHeading) {
          const level = mdHeading[1].length;
          const txt = mdHeading[2];
          flushList();
          if (level === 1) nodes.push(<h1 className="doc-h1" key={`h1-${i}`}>{renderInline(txt)}</h1>);
          else if (level === 2) nodes.push(<h2 className="doc-h2" key={`h2-${i}`}>{renderInline(txt)}</h2>);
          else nodes.push(<h3 className="doc-h3" key={`h3-${i}`}>{renderInline(txt)}</h3>);
          return;
        }
        // 中文标题
        if (/^答[：:]/.test(line)) { flushList(); nodes.push(<h1 className="doc-h1" key={`h1-${i}`}>{renderInline(line.replace(/^答[：:]\s*/, '答'))}</h1>); return; }
        if (/^[一二三四五六七八九十]+、/.test(line)) { flushList(); nodes.push(<h2 className="doc-h2" key={`h2-${i}`}>{renderInline(line)}</h2>); return; }
        if (/^(理由|问题归类|法规解读|解决方案|资金解冻金额评估|紧急行动建议|失败响应|成功响应)[：:]/.test(line)) { flushList(); nodes.push(<h3 className="doc-h3" key={`h3-${i}`}>{renderInline(line)}</h3>); return; }
        // 列表：数字有序 & 星号/短横无序
        if (/^\d+[\.、]/.test(line)) { listBuffer.push(line); return; }
        if (/^(\*|-)\s+/.test(line)) { ulBuffer.push(line); return; }
        nodes.push(<p className="doc-p" key={`p-${i}`}>{renderInline(line)}</p>);
      });
      flushList();
      return <div className="doc-view">{nodes}</div>;
    } catch (_e) {
      // 兜底：发生异常时直接以纯文本展示
      return <div style={{ whiteSpace: 'pre-wrap' }}>{String(text)}</div>;
    }
  };

  // 启动逐字流式展示
  startStream = (messageId, fullText) => {
    const baseDelay = 22; // 每个字符的基础间隔（毫秒）
    let index = 0;
    const timer = setInterval(() => {
      if (!this.isActive) {
        clearInterval(timer);
        this.streamTimers.delete(messageId);
        return;
      }
      index += 1;
      const nextContent = fullText.slice(0, index);
      this.setState((prev) => ({
        chatMessages: prev.chatMessages.map(m => (
          m.id === messageId ? { ...m, content: nextContent } : m
        )),
      }), () => {
        this.scrollToBottom();
      });
      if (index >= fullText.length) {
        clearInterval(timer);
        this.streamTimers.delete(messageId);
      }
    }, baseDelay);
    this.streamTimers.set(messageId, timer);
  };

  // 结束所有流式展示并补全未完成内容
  finishStreaming = () => {
    try {
      this.streamTimers.forEach((timer) => clearInterval(timer));
      this.streamTimers.clear();
      this.setState((prev) => ({
        chatMessages: prev.chatMessages.map(m => {
          if (m.type === 'bot' && typeof m.fullContent === 'string') {
            return { ...m, content: m.fullContent };
          }
          return m;
        })
      }));
    } catch (e) {}
  }

  componentWillUnmount() {
    // 组件卸载时清理所有流式定时器
    this.streamTimers.forEach((timer) => clearInterval(timer));
    this.streamTimers.clear();
    // 标记为未激活，阻止异步回调继续更新
    this.isActive = false;
    // 补全未完成内容并停止流式
    this.finishStreaming();
    // 离开页面时结束所有会话
    this.endAllConversations();
    // 移除事件监听，避免卸载后回调触发 setState
    try {
      if (this._helpTypeHandler) {
        eventBus.removeListener('changeHelpType', this._helpTypeHandler);
      }
      if (this._onHashChange) {
        window.removeEventListener('hashchange', this._onHashChange);
      }
      if (this._onVisibilityChange) {
        document.removeEventListener('visibilitychange', this._onVisibilityChange);
      }
      if (this._onBeforeUnload) {
        window.removeEventListener('beforeunload', this._onBeforeUnload);
      }
    } catch (e) {}
  }
  // 生成答案（直接返回完整内容）
  generateAnswer = (question) => {
    let fullAnswer = '很抱歉，我暂时无法回答这个问题。建议您咨询专业的法律顾问或查阅相关法律条文。如需更详细的法律咨询服务，请联系我们的专业律师团队。';
    Object.keys(this.mockAnswers).forEach(key => {
      if (question.includes(key)) {
        fullAnswer = this.mockAnswers[key];
      }
    });
    return fullAnswer;
  };

  // 获取完整答案
  getFullAnswer = (question) => {
    let fullAnswer = '很抱歉，我暂时无法回答这个问题。建议您咨询专业的法律顾问或查阅相关法律条文。如需更详细的法律咨询服务，请联系我们的专业律师团队。';
    
    Object.keys(this.mockAnswers).forEach(key => {
      if (question.includes(key)) {
        fullAnswer = this.mockAnswers[key];
      }
    });

    return fullAnswer;
  };

  // 处理充值解锁
  handleUnlock = (messageId) => {
    message.info('充值功能开发中，敬请期待！');
    // 这里后续可以接入充值接口
  };

  getUrlParams = (name) => {
    const reg = new RegExp(`(^|&)${ name}=([^&]*)(&|$)`);
    const r = this.props.location.search.substr(1).match(reg);
    if (r != null) return  decodeURIComponent(r[2]); return null;
  };

  getArticleList = () => {
    const { page, pageSize } = this.state;
    const reqData = { page, pageSize, type: 1 };
    API.postArticleList(reqData).then((res) => {
      if (res.status * 1 === 0) {
        this.setState({ article_data: res.extData || {} });
      } else {
        message.error(res.message || "数据加载错误");
      }
    });
  };
 
  handleExperience = (target) => {
    try {
      window.open('https://df.duoduolang.com/#/help', '_blank');
    } catch (_) {}
  };
 
  getQrImgByUrl = (url, size = 160) => {
    const u = encodeURIComponent(url || '');
    const s = Number(size) > 60 ? Number(size) : 160;
    return `https://api.qrserver.com/v1/create-qr-code/?size=${s}x${s}&data=${u}`;
  };
 
  openImageModal = (src, title) => {
    this.setState({
      imageModalVisible: true,
      imageModalSrc: src,
      imageModalTitle: title,
    });
  };

  render() {
    const {
      path, article_data, chatMessages, currentQuestion, isLoading, selectedImage, uploadedImageUrls, agentType
    } = this.state;
    const list = article_data.list || [];
    return (
      <div className="help-center">
        <div className="help_tab">
          <div className="tab_title">方丽莎律师公益服务</div>
          <div className="help_tab_sub">
            <div className={`tab_sub_title ${path === 'question' ? "help_active_tab" : ""}`} onClick={()=>this.setState({path: 'question'})}>
              资金解封&电商税务
            </div>
            <div className={`tab_sub_title ${path === 'compliance' ? "help_active_tab" : ""}`} onClick={()=>this.setState({path: 'compliance'})}>
              财法税合规解决方案
            </div>
            <div className={`tab_sub_title ${path === 'express' ? "help_active_tab" : ""}`} onClick={()=>this.setState({path: 'express'})}>
              虚假物流识别
            </div>
          </div>
        </div>
        <div className="help_box">
          {path === 'express' && (
            <div className="img_box">
              {/* <img src="https://cdn.abc11223.com/source/daifa/wlinfo.png" width="100%"/> */}
              <img src={require("../../../assets/wuliu.png")} width="100%"/>
            </div>
          )}
          {path === 'compliance' && (
            <div className="compliance-page" style={{ padding: '24px 16px' }}>
              <Modal
                visible={this.state.imageModalVisible}
                footer={null}
                onCancel={() => this.setState({ imageModalVisible: false })}
                title={this.state.imageModalTitle}
                width={860}
              >
                <img
                  alt={this.state.imageModalTitle || '预览'}
                  src={this.state.imageModalSrc || ''}
                  style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 8 }}
                />
              </Modal>
              <div style={{ textAlign: 'center', fontSize: 20, fontWeight: 600 }}>财法税合规解决方案</div>
              <div style={{ textAlign: 'center', color: '#666', marginTop: 8 }}>
                现在已经全面进入“以数治税”、“金税四期”的“严征管”的时代，采用财法税合规解决方案，可以保障企业税税平安
              </div>
              <div style={{ textAlign: 'center', marginTop: 28, fontSize: 16, fontWeight: 600 }}>平台介绍</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 24, marginTop: 16 }}>
                <div style={{ flex: '0 0 510px', maxWidth: 510 }}>
                  <div
                    style={{ height: 250, border: '1px solid #e8e8e8', borderRadius: 8, background: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999', cursor: 'zoom-in' }}
                    onClick={() => this.openImageModal(require("../../../assets/shuwu.png"), '税务风险治理系统')}
                  >
                    <img alt="税务风险治理系统" src={require("../../../assets/shuwu.png")} width="100%" height="100%"/>
                  </div>
                  <div style={{ textAlign: 'center', fontWeight: 600, marginTop: 12 }}>税务风险治理系统</div>
                </div>
                <div style={{ flex: '0 0 510px', maxWidth: 510 }}>
                  <div
                    style={{ height: 250, border: '1px solid #e8e8e8', borderRadius: 8, background: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999', cursor: 'zoom-in' }}
                    onClick={() => this.openImageModal(require("../../../assets/xinshui.png"), '薪税社保数智工具')}
                  >
                    <img alt="薪税社保数智工具" src={require("../../../assets/xinshui.png")} width="100%" height="100%"/>
                  </div>
                  <div style={{ textAlign: 'center', fontWeight: 600, marginTop: 12 }}>薪税社保数智工具</div>
                </div>
              </div>
              <div style={{ maxWidth: 1035, margin: '24px auto 0', color: '#333', lineHeight: 1.8 }}>
                基于30多年行业积淀与6年深度研发，我们围绕“四环五法”框架，覆盖企业战略、交易、经营、财务全链路，通过顶层设计与业务模式创新，构建出可复制、标准化的数字化合规解决方案。
              </div>
               <div style={{ maxWidth: 1035, margin: '5px auto 0' }}>
                <div style={{ fontWeight: 600, marginBottom: 8 }}>核心产品</div>
                <ul style={{ padding: 0, margin: 0, listStyle: 'none', color: '#333' }}>
                  <li style={{ margin: '8px 0' }}>
                    <span style={{ color: '#1890ff', marginRight: 8 }}>◆</span>
                    税得安｜税务风险治理系统——精准诊断，系统防治，护航税务安全
                  </li>
                  <li style={{ margin: '8px 0' }}>
                    <span style={{ color: '#1890ff', marginRight: 8 }}>◆</span>
                    薪启元｜薪税社保数智工具——一体化管控，合规增效，解放人力精力
                  </li>
                </ul>
              </div>

              <div style={{ textAlign: 'center', marginTop: 28, fontSize: 18, fontWeight: 600 }}>基础服务</div>
              <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'center', gap: 24, marginTop: 16, overflowX: 'auto' }}>
                <div style={{ flex: '0 0 335px', maxWidth: 335, border: '1px solid #d9d9d9', borderRadius: 6, padding: 20 }}>
                  <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>全方位诊断</div>
                  <div style={{ color: '#666', marginBottom: 16 }}>全方位多维度快速诊断行业企业四大维度风险，包括企业所得税、增值税、个人所得税、社保。</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 12 }}>
                      <div style={{ flex: 1, border: '1px solid #d9d9d9', borderRadius: 10, padding: '15px 16px', background: '#fff' }}>
                        <div style={{ fontWeight: 600 }}>云诊断-个税社保诊断</div>
                        <div style={{ color: '#666' }}>一键诊断个税/社保风险</div>
                      </div>
                      <div style={{ width: 32, height: 32, borderRadius: 4, background: '#fff' }}></div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start', gap: 12 }}>
                      <div style={{ flex: 1, border: '1px solid #d9d9d9', borderRadius: 10, padding: '15px 16px', background: '#fff' }}>
                        <div style={{ fontWeight: 600 }}>云诊断-税务风险诊断</div>
                        <div style={{ color: '#666' }}>一键诊断企业税务风险</div>
                      </div>
                      <div style={{ width: 32, height: 32, borderRadius: 4, background: '#fff' }}></div>
                    </div>
                  </div>
                  <div style={{ textAlign: 'center', marginTop: 33 }}>
                    <Tooltip placement="top" overlayStyle={{ maxWidth: 'none' }} title={<img alt="免费体验二维码" src={this.getQrImgByUrl('https://xqy2-m.sda365.com/invite?source=2112226688943280128')} style={{ width: 160, height: 160 }} />}>
                      <a href="https://xqy2-m.sda365.com/invite?source=2112226688943280128" target="_blank" rel="noopener noreferrer">
                        <span style={{ color: '#1890ff', fontWeight: 600 }}>免费体验</span>
                      </a>
                    </Tooltip>
                  </div>
                </div>
                <div style={{ flex: '0 0 345px', maxWidth: 345, border: '1px solid #d9d9d9', borderRadius: 6, padding: 15 }}>
                  <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>邀请好礼</div>
                  <div style={{ color: '#666', marginBottom: 12 }}>邀请 3 位好友注册，即可免费领取 “税务三合一” 全额抵扣。</div>
                  <div style={{ border: '1px solid #d9d9d9', borderRadius: 10, padding: '12px 12px', background: '#fff' }}>
                    <div style={{ fontWeight: 600 }}>财税云策略-税务三合一</div>
                    <div style={{ color: '#666', marginTop: 6 }}>顶层架构环节、交易环节、经营环节、财务环节导致的增值税、企业所得税的风险因素分析(诊税情)，并根据风险所产生的原因，精准匹配解决方案与策略(治税病)。</div>
                    <div style={{ marginTop: 10 }}>
                      <span style={{ display: 'inline-block', border: '1px solid #d9d9d9', borderRadius: 16, padding: '5px 5px', marginRight: 5, background: '#fff', cursor: 'pointer',marginBottom:5 }}>了解企业涉税风险额</span>
                      <span style={{ display: 'inline-block', border: '1px solid #d9d9d9', borderRadius: 16, padding: '5px 5px', background: '#fff', cursor: 'pointer',marginBottom:5 }}>了解企业多交损失额</span>
                      <span style={{ display: 'inline-block', border: '1px solid #d9d9d9', borderRadius: 16, padding: '5px 5px', marginRight: 5, background: '#fff', cursor: 'pointer',marginBottom:5 }}>企业具体风险因素分析</span>
                      <span style={{ display: 'inline-block', border: '1px solid #d9d9d9', borderRadius: 16, padding: '5px 5px', background: '#fff', cursor: 'pointer',marginBottom:5 }}>解决方案上亿组合</span>
                    </div>
                  </div>
                  <div style={{ textAlign: 'center', marginTop: 12 }}>
                    <Tooltip placement="top" overlayStyle={{ maxWidth: 'none' }} title={<img alt="立即邀请二维码" src={this.getQrImgByUrl('https://xqy2-m.sda365.com/invite?source=2112226688943280128')} style={{ width: 160, height: 160 }} />}>
                      <a href="https://xqy2-m.sda365.com/invite?source=2112226688943280128" target="_blank" rel="noopener noreferrer">
                        <span style={{ color: '#1890ff', fontWeight: 600 }}>立即邀请</span>
                      </a>
                    </Tooltip>
                  </div>
                </div>
                <div style={{ flex: '0 0 335px', maxWidth: 335, border: '1px solid #d9d9d9', borderRadius: 6, padding: 20 }}>
                  <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>合规体验</div>
                  <div style={{ color: '#666', marginBottom: 12 }}>薪税社保解决方案，秒级为每个员工生成个性化的合规设计薪资支付方案，重构员工收入结构，降低企业违法成本。</div>
                  <div style={{ borderRadius: 10, background: '#fff' }}>
                    <img alt="效果测算图" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10 }} src={require("../../../assets/shuzhuangtu.png")} />
                  </div>
                  <div style={{ textAlign: 'center', marginTop: 12 }}>
                    <Tooltip placement="top" overlayStyle={{ maxWidth: 'none' }} title={<img alt="免费体验二维码" src={this.getQrImgByUrl('https://sda-m.sda365.com/plan/')} style={{ width: 160, height: 160 }} />}>
                      <a href="https://sda-m.sda365.com/plan/" target="_blank" rel="noopener noreferrer">
                        <span style={{ color: '#1890ff', fontWeight: 600 }}>免费体验</span>
                      </a>
                    </Tooltip>
                  </div>
                </div>
              </div>
              <div style={{ textAlign: 'center', marginTop: 40, fontSize: 18, fontWeight: 600 }}>付费服务</div>
              <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'center', gap: 24, marginTop: 18, overflowX: 'auto' }}>
                <div style={{ flex: '0 0 520px', maxWidth: 520, border: '1px solid #d9d9d9', borderRadius: 6, padding: 20 }}>
                  <div style={{ textAlign: 'center', fontSize: 16, fontWeight: 600, marginBottom: 16 }}>企业税务风险解决方案</div>
                  <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: '12px 16px' }}>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>财税云策略系列</div>
                    <div style={{ display: 'flex'}}>
                      <div style={{ flex: 1 }}>
                        <div style={{ margin: '6px 0' }}>· 税务三合一</div>
                        <div style={{ margin: '6px 0' }}>· 上下游发票穿透报告</div>
                        <div style={{ margin: '6px 0' }}>· 投资尽调报告</div>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ margin: '6px 0' }}>· 经营财务分析</div>
                        <div style={{ margin: '6px 0' }}>· 工商全景报告</div>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ margin: '6px 0' }}>· 偿债能力分析报告</div>
                        <div style={{ margin: '6px 0' }}>· 逸学贷融资报告</div>
                      </div>
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>薪税云策略系列</div>
                    <div style={{ margin: '6px 0' }}>· 薪税云策略报告</div>
                  </div>
                  <div style={{ color: '#666', marginTop: 12, textAlign: 'center' }}>
                    为企业进行全面诊断，200多种针对应解决方案，上亿种方案组合，帮助企业有效的解决各种疑难杂症。
                  </div>
                  <div style={{ textAlign: 'center', marginTop: 10 }}>
                    <Tooltip placement="top" overlayStyle={{ maxWidth: 'none' }} title={<img alt="立即体验二维码" src={this.getQrImgByUrl('https://xqy2-m.sda365.com/invite?source=2112226688943280128')} style={{ width: 160, height: 160 }} />}>
                      <a href="https://xqy2-m.sda365.com/invite?source=2112226688943280128" target="_blank" rel="noopener noreferrer">
                        <span style={{ color: '#1890ff', fontWeight: 600 }}>立即体验</span>
                      </a>
                    </Tooltip>
                  </div>
                </div>
                <div style={{ flex: '0 0 520px', maxWidth: 520, border: '1px solid #d9d9d9', borderRadius: 6, padding: 20 }}>
                  <div style={{ textAlign: 'center', fontSize: 16, fontWeight: 600, marginBottom: 16 }}>多维度薪资支付方案</div>
                  <div style={{ borderRadius: 6,background: '#fff' }}>
                    <img
                      alt="薪资发放支付方案示意图"
                      style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 6, }}
                      src={require("../../../assets/salary_demo.svg")}
                    />
                  </div>
                  <div style={{ color: '#666', marginTop: 12, textAlign: 'center' }}>
                    帮助企业优化社保成本,避免企业“一刀切”按最低基数缴纳社保,合法重构员工收入结构，实现企业降本增效、人力高效管理的目标。
                  </div>
                  <div style={{ textAlign: 'center', marginTop: 10}}>
                    <Tooltip placement="top" overlayStyle={{ maxWidth: 'none' }} title={<img alt="立即体验二维码" src={this.getQrImgByUrl('https://xqy2-m.sda365.com/invite?source=2112226688943280128')} style={{ width: 160, height: 160 }} />}>
                      <a href="https://xqy2-m.sda365.com/invite?source=2112226688943280128" target="_blank" rel="noopener noreferrer">
                        <span style={{ color: '#1890ff', fontWeight: 600 }}>立即体验</span>
                      </a>
                    </Tooltip>
                  </div>
                </div>
              </div>

              <div style={{ textAlign: 'center', marginTop: 48, fontSize: 18, fontWeight: 600 }}>行业痛点</div>
              <div style={{ maxWidth: 1000, margin: '10px auto 0', color: '#333', lineHeight: 1.8, textAlign: 'center' }}>
                      金税四期与平台数据直报新规落地后，电商行业税费合规矛盾凸显，在多平台经营、无票采购、刷单冲量等行业特性下，如何解决税负适配失衡、票据凭证缺失、公私账混用等传统痛点？怎样平衡合规整改成本与经营压力，同时实现合法降负，推动行业在透明化监管下合规发展？
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 24, marginTop: 18 }}>
                <div style={{ flex: '0 0 335px', maxWidth: 335, border: '1px solid #d9d9d9', borderRadius: 6, padding: 16 }}>
                  <div style={{ textAlign: 'center', fontSize: 16, fontWeight: 600, marginBottom: 12 }}>刷单多缴税风险</div>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 12 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, position: 'relative', background: '#fff' }}>
                      <svg width="32" height="32" viewBox="0 0 32 32" style={{ position: 'absolute', top: 0, left: 0 }}>
                        <line x1="4" y1="4" x2="28" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                        <line x1="28" y1="4" x2="4" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                      </svg>
                    </div>
                    <div style={{ background: '#f5f5f5', border: '1px solid #e5e5e5', borderRadius: 8, padding: '10px 12px', color: '#333', flex: 1 }}>
                      老师您好，关于刷单多交税风险怎么解决？
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start', gap: 8, marginBottom: 12 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff' }}></div>
                    <div style={{ background: '#15a34a', borderRadius: 8, padding: '10px 12px', color: '#fff', flex: 1 }}>
                      可针对历年的问题，调整账务与税务申报、收集业务链证据；针对往后的合规问题，优化业务、财务、资金之间的系统合规方案。
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 12 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, position: 'relative', background: '#fff' }}>
                      <svg width="32" height="32" viewBox="0 0 32 32" style={{ position: 'absolute', top: 0, left: 0 }}>
                        <line x1="4" y1="4" x2="28" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                        <line x1="28" y1="4" x2="4" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                      </svg>
                    </div>
                    <div style={{ background: '#f5f5f5', border: '1px solid #e5e5e5', borderRadius: 8, padding: '10px 12px', color: '#333', flex: 1 }}>
                      大致方向按照您说的处理完成后，能达到什么效果呢？
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start', gap: 8 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff' }}></div>
                    <div style={{ background: '#15a34a', borderRadius: 8, padding: '10px 12px', color: '#fff', flex: 1 }}>
                       按照合规方案处理后，能够避免缴纳冤枉税。
                    </div>
                  </div>
                </div>

                <div style={{ flex: '0 0 345px', maxWidth: 345, border: '1px solid #d9d9d9', borderRadius: 6, padding: 16 }}>
                  <div style={{ textAlign: 'center', fontSize: 16, fontWeight: 600, marginBottom: 12 }}>私户收款不交税</div>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 12 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, position: 'relative', background: '#fff' }}>
                      <svg width="32" height="32" viewBox="0 0 32 32" style={{ position: 'absolute', top: 0, left: 0 }}>
                        <line x1="4" y1="4" x2="28" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                        <line x1="28" y1="4" x2="4" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                      </svg>
                    </div>
                    <div style={{ background: '#f5f5f5', border: '1px solid #e5e5e5', borderRadius: 8, padding: '10px 12px', color: '#333', flex: 1 }}>
                      老师您好，平台推送税务店铺数据后被发现有隐匿收入怎么解决？
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start', gap: 8, marginBottom: 12 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff' }}></div>
                    <div style={{ background: '#15a34a', borderRadius: 8, padding: '10px 12px', color: '#fff', flex: 1 }}>
                      首先立即停止，拉取平台全部交易流水，整理出一份真实收入与申报收入差异明细表，准备完整的证据链，并且请财税专业团队在法律范围内去争取最优方案；第二，今后公私必须分离，然后通过顶层架构和股权设计及业务模式重构等形式合规。
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 12 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, position: 'relative', background: '#fff' }}>
                      <svg width="32" height="32" viewBox="0 0 32 32" style={{ position: 'absolute', top: 0, left: 0 }}>
                        <line x1="4" y1="4" x2="28" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                        <line x1="28" y1="4" x2="4" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                      </svg>
                    </div>
                    <div style={{ background: '#f5f5f5', border: '1px solid #e5e5e5', borderRadius: 8, padding: '10px 12px', color: '#333', flex: 1 }}>
                      大致方向按照您说的处理完成后，能达到什么效果呢？
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start', gap: 8 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff' }}></div>
                    <div style={{ background: '#15a34a', borderRadius: 8, padding: '10px 12px', color: '#fff', flex: 1 }}>
                       按照合规方案处理后，能够杜绝隐匿收入，不交冤枉税，避免罚款、滞纳金。
                    </div>
                  </div>
                </div>

                <div style={{ flex: '0 0 335px', maxWidth: 335, border: '1px solid #d9d9d9', borderRadius: 6, padding: 16 }}>
                  <div style={{ textAlign: 'center', fontSize: 16, fontWeight: 600, marginBottom: 12 }}>虚开发票陷阱</div>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 12 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, position: 'relative', background: '#fff' }}>
                      <svg width="32" height="32" viewBox="0 0 32 32" style={{ position: 'absolute', top: 0, left: 0 }}>
                        <line x1="4" y1="4" x2="28" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                        <line x1="28" y1="4" x2="4" y2="28" stroke="#bfbfbf" strokeWidth="1" />
                      </svg>
                    </div>
                    <div style={{ background: '#f5f5f5', border: '1px solid #e5e5e5', borderRadius: 8, padding: '10px 12px', color: '#333', flex: 1 }}>
                      老师您好，如何避免虚开发票的风险呢？
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start', gap: 8, marginBottom: 12 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff' }}></div>
                    <div style={{ background: '#15a34a', borderRadius: 8, padding: '10px 12px', color: '#fff', flex: 1 }}>
                      充分运用好2018年28号文件等相关政策，通过在业务流程和业务模式上优化，并且内部设置严格的发票管理制度与合同审批流程，坚守“四流合一”原则。
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'flex-start', gap: 8 }}>
                    <div style={{ width: 32, height: 32, border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff' }}></div>
                    <div style={{ background: '#15a34a', borderRadius: 8, padding: '10px 12px', color: '#fff', flex: 1 }}>
                      避免刑事责任风险，不交冤枉税，避免罚款、滞纳金。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {path === 'question' && (
            <div>
              <div className="recharge">方丽莎律师，毕业于浙江大学法学院，法律硕士（法学），从事法律行业3年。
                擅长领域：电商解封业务、知识产权业务、电商业务。微信号：13216855669
                <Tooltip placement="top" overlayClassName="license-tooltip" overlayStyle={{ maxWidth: 'none' }} title={<img src={require("../../../assets/license.jpg")} alt="律师执业证" style={{ width: 360, display: 'block' }} />}>
                  <span style={{ display: 'inline-block', marginLeft: 8, cursor: 'pointer', verticalAlign: 'text-bottom' }} aria-label="查看执业证">
                    <SafetyCertificateOutlined style={{ fontSize: '1em', color: '#1890ff', lineHeight: 1, verticalAlign: 'text-bottom' }} />
                  </span>
                </Tooltip>
             </div>
              
              {/* 智能问答区域 */}
              <div className="ai-chat-container">
                <div className="ai-chat-header">
                  <div className="header-content">
                    <div className="header-left">
                      <div className="agent-buttons" style={{marginBottom: 6}}>
                        <Button 
                          style={{ borderRadius: 6}}
                          type={agentType === 'unblock' ? 'primary' : 'default'}
                          onClick={() => this.handleConfirmSwitch('unblock')}
                        >
                          🤖 电商资金解封助手
                        </Button>
                        <Button 
                          style={{ marginLeft: 8 , borderRadius: 6}}
                          type={agentType === 'tax' ? 'primary' : 'default'}
                          onClick={() => this.handleConfirmSwitch('tax')}
                        >
                          🤖 电商税务问题咨询
                        </Button>
                      </div>
                      {/* <div style={{ marginTop: 6 }}>
                        <span style={{fontSize: 13,marginRight:5,color: '#096dd9',}}>每人有免费2次提问机会</span>
                        <span style={{
                          display: 'inline-block',
                          padding: '4px 8px',
                          background: 'rgba(24,144,255,0.1)',
                          color: '#096dd9',
                          border: '1px solid #d0e7ff',
                          borderRadius: 6,
                          fontSize: 13,
                        }}>
                          10分钟之前有用户咨询过，仅需3分钟就得到了满意答案。
                        </span>
                      </div> */}
                    </div>
                    <div className="header-right">
                      <div className="lawyer-consultation">
                        <span className="consultation-text">方丽莎律师</span>
                        <div className="consultation-icon">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.11 3.89 23 5 23H11V21H5V3H13V9H21ZM14 15.5C14 14.11 15.11 13 16.5 13S19 14.11 19 15.5 17.89 18 16.5 18 14 16.89 14 15.5ZM16.5 19C18.43 19 20 17.43 20 15.5S18.43 12 16.5 12 13 13.57 13 15.5 14.57 19 16.5 19Z" fill="#1890ff"/>
                          </svg>
                          <div className="qr-code-tooltip">
                            <div className="qr-code">
                              <img src={require("../../../assets/code3.jpg")} alt="" width="100px" />
                            </div>
                            <p className="qr-text">扫码联系专业律师</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p style={{ color: '#615e5e'}}>当前智能体：{agentType === 'unblock' ? '电商资金解封助手，商家在拼多多、淘宝等电商平台经营时，常因滥发信息、售假等原因，遭遇平台冻结货款账户、无法提现的困境。本智能体致力于为此类商家提供专业的解封咨询与可行性评估。' 
                      : '电商税务问题咨询，本智能体为电商商家提供专业的税务咨询与规划服务，涵盖税务合规缴纳、政策解读、结构性税负优化等核心环节。'}</p>
                </div>
                
                {/* 对话历史 */}
                <div className="chat-messages" ref={this.chatMessagesRef}>
                  {chatMessages.length === 0 && (
                    <div className="chat-welcome">
                      <div className="welcome-message">
                        {agentType === 'unblock' && (
                            <p style={{textAlign:'left'}}>👋 您好！我是您的智能法律助手，本智能体由方丽莎律师基于对百余份真实民事判决书的系统检索与研究打造。可以精准识别冻结类型、评估解封可能性，并指导准备起诉所需材料。</p>
                        )}
                        {agentType === 'tax' && (
                          <p style={{textAlign:'left'}}>👋 您好！我是您的智能法律助手，本智能体由方丽莎律师整合了多部现行有效的电商税收法律法规与征管政策，并融入了行业专家对前沿税务动态的深度分析与解读，致力于为您提供兼具合规性与前瞻性的税务咨询。</p>
                        )}
                        <p className="ai-hover">您可以根据当前智能体，点击下面的示例问题：</p>
                        <div className="question-suggestions">
                          {agentType === 'unblock' && (
                            <div className="example-item">
                              <span onClick={() => this.setState({currentQuestion: '我的一家拼多多店铺还有三万多的货款，但是现在提不出来。平台说我销售假货，有什么办法可以拿出来？'})}>
                                问：我的一家拼多多店铺还有三万多的货款，但是现在提不出来。平台说我销售假货，有什么办法可以拿出来？
                              </span>
                              {/* <Button size="small" type="link" onClick={() => this.openAnswerModal('问：我的一家拼多多店铺还有三万多的货款，但是现在提不出来。平台说我销售假货，有什么办法可以拿出来？')}>答</Button> */}
                            </div>
                          )}
                          {agentType === 'tax' && (
                            <div className="example-item">
                              <span onClick={() => this.setState({currentQuestion: '我是做电商的，目前三个店铺年销售额大概是 5000 万左右，利润只有 5-7 个点，我交税之后公司是不是要亏本了？'})}>
                                问：我是做电商的，目前三个店铺年销售额大概是 5000 万左右，利润只有 5-7 个点，我交税之后公司是不是要亏本了？
                              </span>
                              {/* <Button size="small" type="link" onClick={() => this.openAnswerModal('问：我是做电商的，目前三个店铺年销售额大概是 5000 万左右，利润只有 5-7 个点，我交税之后公司是不是要亏本了？')}>答</Button> */}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {chatMessages.map((msg) => (
                    <div key={msg.id} className={`chat-message ${msg.type}`}>
                      <div className="message-header">
                        <span className="message-sender">
                          {msg.type === 'user' 
                            ? '👤 您' 
                            : (msg.agentType === 'tax' ? '🤖 电商税务咨询' : '🤖 电商解封助手')}
                        </span>
                        <span className="message-time">{msg.timestamp}</span>
                      </div>
                      <div className="message-content" style={{ position: 'relative', paddingRight: 28, paddingBottom: 26 }}>
                        {msg.type === 'bot' ? this.renderDoc(msg.content || '') : msg.content}
                        {Array.isArray(msg.images) && msg.images.length > 0 && (
                          <div className="chat-image-list" style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6 }}>
                            {msg.images.map((url) => (
                              <img key={url} className="chat-image" src={url} alt="用户上传图片" style={{ width: 72, height: 72, borderRadius: 6, objectFit: 'cover', border: '1px solid #eee' }} />
                            ))}
                          </div>
                        )}
                        {msg.type === 'bot' && (
                          <div style={{ position: 'absolute', right: 6, bottom: 6 }}>
                            <Tooltip title="复制">
                              <Button
                                type="text"
                                size="small"
                                icon={<CopyOutlined />}
                                onClick={() => this.handleCopy(msg.fullContent || msg.content)}
                              />
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                  
                  {isLoading && (
                    <div className="chat-message bot">
                      <div className="message-header">
                        <span className="message-sender">🤖 法律助手</span>
                        <span className="message-time">正在思考中...</span>
                      </div>
                      <div className="message-content">
                        <Spin size="small" /> 正在为您分析法律问题，请稍候...
                      </div>
                    </div>
                  )}
                </div>
                
                {/* 输入区域 */}
                <div className="chat-input-area">
                  <div className="chat-input-inner">
                    {(this.state.uploadedImageUrls || []).length > 0 && (
                      <div className="selected-image-preview" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {this.state.uploadedImageUrls.map((url) => (
                          <div key={url} style={{ position: 'relative', width: 72, height: 72, borderRadius: 6, overflow: 'hidden', border: '1px solid #eee' }}>
                            <img src={url} alt="预览图片" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            <button type="button" className="clear-image-btn" onClick={() => this.handleRemoveImage(url)} style={{ position: 'absolute', top: 2, right: 2, background: 'rgba(0,0,0,.45)', color: '#fff', border: 0, borderRadius: 10, width: 18, height: 18, lineHeight: '18px', cursor: 'pointer' }}>×</button>
                          </div>
                        ))}
                        {/* <button type="button" className="clear-image-btn" onClick={this.handleClearImage} style={{ height: 26, lineHeight: '26px' }}>清空</button> */}
                      </div>
                    )}
                    <TextArea
                      value={currentQuestion}
                      onChange={(e) => this.setState({currentQuestion: e.target.value})}
                      placeholder={agentType === 'unblock' 
                        ? '请输入您的问题，例如：问：我的一家拼多多店铺还有三万多的货款，但是现在提不出来。平台说我销售假货，有什么办法可以拿出来？'
                        : '请输入您的问题，例如：问：我是做电商的，目前三个店铺年销售额大概是 5000 万左右，利润只有 5-7 个点，我交税之后公司是不是要亏本了？'}
                      autoSize={{ minRows: 2, maxRows: 4 }}
                      onPressEnter={(e) => {
                        if (!e.shiftKey) {
                          e.preventDefault();
                          this.handleAskQuestion();
                        }
                      }}
                    />
                    <input type="file" accept="image/*" multiple ref={this.imageInputRef} onChange={this.handleImageSelected} style={{ display: 'none' }} />
                    <button type="button" className="image-upload-icon" aria-label="选择图片" onClick={() => this.imageInputRef.current && this.imageInputRef.current.click()}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5a2 2 0 012-2h8l6 6v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z" stroke="#666" strokeWidth="1.5"/><path d="M9.5 12.5l2.5 2.5 3.5-3.5 3.5 3.5" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><circle cx="8" cy="8" r="1.5" fill="#666"/></svg>
                    </button>
                  </div>
                  <div className="input-actions">
                    <span className="input-tip">按 Enter 发送，Shift + Enter 换行</span>
                    <Button 
                      type="primary" 
                      onClick={this.handleAskQuestion}
                      loading={isLoading}
                      disabled={!currentQuestion.trim() && (!(uploadedImageUrls)||uploadedImageUrls.length===0)}
                    >
                      发送问题
                    </Button>
                  </div>
                </div>
              </div>

              {/* 原有的文章列表 */}
              {/* <div className="articles-section">
                <div className="recharge" style={{marginTop: '40px'}}>常见问题文档</div>
                {list.map((item) => (
                  <div className="question" key={item.articleId}>
                    <div>{item.title}</div>
                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                  </div>
                ))}
              </div> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CollectList;
